/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Grid_EyebrowInputs */

const es_gift_grid_eyebrow = /** @type {(inputs: Gift_Grid_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige el importe`)
};

const gl_gift_grid_eyebrow = /** @type {(inputs: Gift_Grid_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elixe o importe`)
};

const en_gift_grid_eyebrow = /** @type {(inputs: Gift_Grid_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose amount`)
};

/**
* | output |
* | --- |
* | "Choose amount" |
*
* @param {Gift_Grid_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_grid_eyebrow = /** @type {((inputs?: Gift_Grid_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Grid_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_grid_eyebrow(inputs)
	if (locale === "en") return en_gift_grid_eyebrow(inputs)
	return es_gift_grid_eyebrow(inputs)
});